export default __webpack_public_path__ + "static/media/5.fb48cdb0.jpg";